Ext.define('SA.data.quickreport.QuickReportView', {
    alias: 'view.quickReport',
    extend: 'SA.data.View',

    mixins: {
        locations: 'SA.data.mixin.ManyLocations'
    },

    statics: {
        create({project, country, censusRelease, name, locationItems}) {
            var data = {
                type: 'quickReport',
                buildingBlocksCensusRelease: censusRelease,
                filterVisibility: 'strikeout',
                quickReportTemplate: `${country.getCode()} - Demographic Overview`,
                locationItems,
                name
            };

            return new SA.data.quickreport.QuickReportView({project, data});
        },

        supportsAttribute() {
            return false;
        }
    },

    addAttribute(attribute) {
        this.project.addAttribute(attribute);

        this.fireEvent('invoke:addAttribute');
    },

    addLocationImpl(location) {
        this.nullifyCurrentRequest();

        this.mixins.locations.addLocationImpl.call(this, location);

        this.project.addLocation(location);
    },

    areTemplatesAvailable() {
        var Templates = SA.data.quickreport.QuickReportTemplates;

        return Templates.didLoad() && Templates.hasTypesForCountry(this.getCountry());
    },

    async checkAvailability() {
        var Templates = SA.data.quickreport.QuickReportTemplates;

        await Templates.loaded();

        return Templates.hasTypesForCountry(this.getCountry());
    },

    createController() {
        return new SA.QuickReportController(this);
    },

    getAttributes() {
        return []; 
    },

    getReferencedAttributes() {
        return this.areTemplatesAvailable() ? this.getQuickReportTemplateItem().getAttributes() : [];
    },

    getQuickReportTemplate() {
        return this.data.quickReportTemplate;
    },

    getQuickReportTemplateItem() {
        var Templates = SA.data.quickreport.QuickReportTemplates,
            country = this.getCountry(),
            type = this.getQuickReportTemplateType();

        return Templates.get(country, type);
    },

    getQuickReportTemplateType() {
        var template = this.getQuickReportTemplate(),
            country = this.getCountry(),
            prefixRe = new RegExp('^' + country + ' - ');

        return template.replace(prefixRe, '');
    },

    getReportContentDropDownItems() {
        var Templates = SA.data.quickreport.QuickReportTemplates;

        return this.areTemplatesAvailable() ? Templates.getTypesForCountry(this.getCountry()) : [];
    },

    async getReportData() {
        await SA.data.quickreport.QuickReportTemplates.loaded();

        var me = this,
            request = getRequest();

        this.request = request;

        return new Promise(resolve => {
            request.then(data => {
                if (this.request !== request) {
                    return;
                }

                resolve(data);
            });
        });

        function getRequest() {
            var Request = SA.data.quickreport.QuickReportDataRequest,
                templateItem = me.getQuickReportTemplateItem(),
                locations = me.getLocations();

            return Request.request(templateItem, locations);
        }
    },

    hasCountry() {
        var locationSeries = SA.Institution.getCountry(this.getCountry()).getLocationSeries();

        return this.containsLocation(locationSeries);
    },

    isSavable() {
        return this.getLocations().length;
    },

    nullifyCurrentRequest() {
        this.request = null;
    },

    removeLocationImpl(location) {
        this.nullifyCurrentRequest();

        this.mixins.locations.removeLocationImpl.call(this, location);
    },

    reportContentDropDownItemsLoaded() {
        return SA.data.quickreport.QuickReportTemplates.loaded();
    },

    setQuickReportTemplate(template) {
        if (this.data.quickReportTemplate !== template) {
            this.nullifyCurrentRequest();
        }

        this.setWithEvent('quickReportTemplate', template);
    },

    setQuickReportTemplateType(type) {
        var template = this.getCountry() + ' - ' + type;

        this.setQuickReportTemplate(template);
    }
});